import React, { useState, useRef } from 'react';
import c from 'classnames';
import styles from './StemPage.css';
import { submitStemForm } from '../../apis/dumpert';
import { useSelector } from 'react-redux';
import {
  selectUsername, UserState,
} from '../../ducks';
import { Notification } from '../notification';
import { useAuthCheck } from '../auth';
import {
  StemForm,
  StemIntroduction,
  StemThankYou,
} from './';
import { STEMPAGE, TOPZOVEEL } from '../../lib/labels';
import { Loading } from '../loading';

export const StemPage = ({ history }) => {

  const username = useSelector(selectUsername);
  const [userState, isLoggedIn] = useAuthCheck(history);
  const [showIntro, setShowIntro] = useState(true);
  const [videoList, setvideoList] = useState([]);
  const [userVoted, setUserVoted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const notificationRef = useRef();
  const inputRef = useRef();

  const onSelect = input => {
    if (!videoList.filter(item => item.id === input.id).length > 0) {
      setvideoList([
        ...videoList,
        input,
      ]);
      notificationRef.current.addNotification(STEMPAGE.NOTIFICATIONS.ADDED, 'success');
    } else {
      notificationRef.current.addNotification(STEMPAGE.NOTIFICATIONS.DOUBLE, 'info');
    }
  };

  const onRemove = id => {
    const { current } = inputRef;
    current.focus();

    const removeItem = videoList.findIndex(item => item.id === id);
    const newList = [
      ...videoList.slice(0, removeItem),
      ...videoList.slice(removeItem + 1),
    ];
    setvideoList([
      ...newList,
    ]);
    notificationRef.current.addNotification(STEMPAGE.NOTIFICATIONS.DELETED, 'error');
  };

  const onSubmit = e => {
    e.preventDefault();
    const confirmChoice = confirm(STEMPAGE.CONFIRM.CHOICE);
    if (confirmChoice === true) {
      setIsLoading(true);
      setError(null);
      sendList(videoList);
    } else {
      setError(STEMPAGE.CONFIRM.CANCELED);
    }
  };

  const sendList = videoList => {
    const stems = {
      stems: [
        ...videoList.map(item => ({ key: `/${item.id}`, value: '1' })),
      ],
    };
    submitStemForm(stems)
      .then(() => {
        setIsLoading(false);
        setUserVoted(true);
      })
      .catch(error => {
        setIsLoading(false);
        setError(error.message);
      });
  };

  return (
    <>{UserState.PENDING === userState && <Loading whatIsLoading='pagina' />}
      {isLoggedIn && (
        <>
          <Notification ref={notificationRef} />
          <div className={styles['zoveel-logo']}>
            <img src={TOPZOVEEL.IMAGES.LOGO} alt="Dumpert TopZoveel" width="100%" />
          </div>
          <div className={c(['container-spacious'], styles.stem)}>
            <section>
              {showIntro &&
                <StemIntroduction
                  username={username}
                  setShowIntro={setShowIntro}
                />
              }
              {(!showIntro && !userVoted) &&
                <StemForm
                  videoList={videoList}
                  onSelect={onSelect}
                  onRemove={onRemove}
                  onSubmit={onSubmit}
                  isLoading={isLoading}
                  inputRef={inputRef}
                  error={error}
                />
              }
              {userVoted && <StemThankYou />}
            </section>
            <section 
              className={styles['hide-mobile']} 
              style={{ 'background': 'url(https://assets.dumpert.nl/dumpert_topzoveel-pattern.png)' }}
            ></section>
          </div>
        </>
      )}
    </>
  );
};